<div class="input-group flex-nowrap" [style.min-width]="width">
  <input [ngClass]="ngControl?.valid ? 'ng-valid' : 'ng-invalid'" [class.is-invalid]="isInvalid" class="form-control {{inputClass}}" type="text"
         [name]="name" container="body"
         [ngModel]="datetime | date: inputDatetimeFormat"
         [disabled]='disabled' #p1="ngbPopover"
         [ngbPopover]="calendarContent" [popoverClass]="'p-0'"
         (change)="onInputChange($event)"
         (blur)="inputBlur($event)"/>
  <div class="btn btn-outline-default" *ngIf="!disabled" (click)="p1.toggle()">
    <svg viewBox="0 0 8 8" class="icon" inlineSVG="#calendar-days">
    </svg>
  </div>
</div>
<ng-template #calendarContent>
  <ng-container *ngIf="!showTimePicker">
    <ngb-datepicker #dp name="datepicker" [ngModel]="datetime" (ngModelChange)="onDateChange($event)" [startDate]="getStartDate()"></ngb-datepicker>
    <button class="btn w-100 btn-outline-secondary" [ngbPopover] type="button" (click)="toggleDateTimeState($event)" *ngIf="showTime">
      {{(datetime | date: inputTimeFormat) || '-'}}
    </button>
  </ng-container>
  <div *ngIf="showTimePicker">
    <div class="mt-auto">
      <ngb-timepicker #tp name="timepicker" [ngModel]="time" (ngModelChange)="onTimeChange($event)" [seconds]="seconds"
                      [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep"></ngb-timepicker>
    </div>
    <button class="btn w-100 btn-outline-secondary" [ngbPopover]="calendarContent" type="button" (click)="toggleDateTimeState($event)">
      {{(datetime | date: inputTimeFormat) || '-'}}
    </button>
  </div>
</ng-template>
